import { useState } from "react";
import { X } from "lucide-react";
import { reportBotMessage } from "@/api/chat";

interface Props {
  open: boolean;
  messageContent: string;
  messageTimestamp?: string;
  onClose: () => void;
}

export function ReportDialog({ open, messageContent, messageTimestamp, onClose }: Props) {
  const [note, setNote] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [result, setResult] = useState<"ok" | "err" | null>(null);

  if (!open) return null;

  async function submit() {
    setSubmitting(true);
    setResult(null);
    try {
      await reportBotMessage(messageContent, note || undefined, messageTimestamp);
      setResult("ok");
      setTimeout(() => {
        setNote("");
        setResult(null);
        onClose();
      }, 1500);
    } catch {
      setResult("err");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div
      className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="bg-card text-text rounded-xl max-w-lg w-full p-5 shadow-xl border border-border"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-base font-semibold">Segnala comportamento anomalo</h3>
          <button onClick={onClose} className="text-text/60 hover:text-text">
            <X size={18} />
          </button>
        </div>
        <div className="mb-3 p-2 bg-background/50 border border-border rounded text-xs max-h-32 overflow-y-auto whitespace-pre-wrap">
          {messageContent.slice(0, 500)}
          {messageContent.length > 500 ? "…" : ""}
        </div>
        <textarea
          className="w-full border border-border bg-background rounded px-3 py-2 text-sm min-h-[100px] focus:outline-none focus:ring-2 focus:ring-brand"
          placeholder="Descrivi il problema (facoltativo)"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          disabled={submitting}
        />
        {result === "ok" && (
          <p className="text-xs text-green-600 mt-2">Segnalazione inviata, grazie.</p>
        )}
        {result === "err" && (
          <p className="text-xs text-red-600 mt-2">Errore invio. Riprova più tardi.</p>
        )}
        <div className="flex justify-end gap-2 mt-4">
          <button
            onClick={onClose}
            className="px-3 py-1.5 text-sm border border-border rounded hover:bg-background/50"
            disabled={submitting}
          >
            Annulla
          </button>
          <button
            onClick={submit}
            className="px-3 py-1.5 text-sm bg-brand text-white rounded hover:opacity-90 disabled:opacity-50"
            disabled={submitting}
          >
            {submitting ? "Invio..." : "Invia"}
          </button>
        </div>
      </div>
    </div>
  );
}
